module.exports = __webpack_public_path__ + "static/img/bg-id-card-front.c5dc9c3a.png";